import querystring from "querystring"
let params = querystring.decode(window.location.search.slice(1))
let {
  onlineClassId,
  roomId,
  userId,
  userRole,
  lessonId,
  nickname,
  lessonName,
  scheduledDateTime,
  lessonSerialNumber,
  duration
} = params

let webserverURL
let TRPM_TOKEN = params.TRPM_TOKEN
// webserver的链接中中不需要onlineClassId、TRPM_TOKEN
delete params.onlineClassId
delete params.TRPM_TOKEN

const webserverURL_params = querystring.encode(params)

if (!/test-|qa-|stage-|localhost|192\.168\./.test(window.location.origin)) {
  webserverURL = `https://openclass-webserver.vipkid.com.cn/api/webserver/room/enterRoom?${webserverURL_params}`
} else {
  webserverURL = `https://test-openclass-webserver.vipkid-qa.com.cn/api/webserver/room/enterRoom?${webserverURL_params}`
}

// TRPM_TOKEN 老师端接口需要的header
export {
  TRPM_TOKEN,
  webserverURL,
  onlineClassId,
  roomId,
  userId,
  userRole,
  lessonId,
  nickname,
  lessonName,
  scheduledDateTime,
  lessonSerialNumber,
  duration
}
